import NotFoundComponentAlt from "./NotFoundComponentAlt";

export default NotFoundComponentAlt;